import { Input } from '@euler/components/form/Input';
import { memo } from 'react';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { useTextInputRow } from '../../functions/useTextInputRow';
import { Cell } from '../components/Cell';
import { IconWrapper } from '../components/IconWrapper';
import { Row } from '../components/Row';
import { TextIcon } from '../components/TextIcon';

/**
 * Only shown for a vehicle with no ISO VIN. Every other vehicle gets its model
 * year from the decoded VIN, so this is the one case where nothing but the
 * operator can supply it — and without it the vehicle has no age at all.
 */
export const VehicleModelYearRow = memo((props: { disabled?: boolean }) => {
  const {
    theme,
    formController: { form },
  } = useOrderFlowContext();

  const { iconColor, placeholderColor } = theme;
  const { inputRef, inputStyle, onCellPress } = useTextInputRow();

  const modelYear = form.vehicleInfo.value?.vehicleModelYear;

  // Checked at render, not when the sections are built: the operator flips the
  // toggle while the form is open.
  if (!form.isNonStandardVin.value) {
    return null;
  }

  return (
    <Row
      icon={
        <IconWrapper>
          <TextIcon text="年款" color={iconColor} />
        </IconWrapper>
      }
      onPress={onCellPress}
      {...props}
    >
      <Cell label="车辆年款">
        <Input
          inputRef={inputRef}
          style={inputStyle}
          placeholderTextColor={placeholderColor}
          editable={!props.disabled}
          value={modelYear ? String(modelYear) : ''}
          placeholder="请输入车辆年款，如 2018"
          keyboardType="number-pad"
          returnKeyType="done"
          returnKeyLabel="确认"
          clearButtonMode="while-editing"
          maxLength={4}
          onChangeText={x => {
            const year = Number(x);
            form.vehicleInfo.update(() => ({
              vehicleModelYear: x && year > 0 ? year : undefined,
            }));
          }}
          tag="vehicleModelYear"
        />
      </Cell>
    </Row>
  );
});
